import { useMemo } from 'react';

import { useAppSelector } from '@fd/customHooks/useAppSelector';
import { useQuery } from '@tanstack/react-query';

import { permissionsSelector } from '../../../selectors/permissions.selector';
import { flagService } from '../../../services/flagService';
import { getOnboardingV3Status, getOnboardingV3StatusKey } from '../onboardingV3.service';

type OnboardingStatus = 'off' | 'in_progress' | 'completed';

// hook so that changes from flag to query are easier to change
export const useHasAccessToOnboardingV3 = () => {
  // re-using this flag just to enable quick revert and I don't want to add another
  const onboardingWizardV3UsingApi = useAppSelector((state) =>
    flagService.isFlagOn(state, 'enableOnboardingV3WizardConfig')
  );
  const orgId = useAppSelector((state) => state.currentApp?.OrgId || '');
  const isOnboardingWizardAutoSaveEnabled = useAppSelector((state) =>
    flagService.isFlagOn(state, 'enableOnboardingV3WizardAutoSave')
  );

  const { data } = useQuery({
    queryKey: [orgId, getOnboardingV3StatusKey],
    queryFn: () => getOnboardingV3Status(orgId),
    enabled: !!orgId && onboardingWizardV3UsingApi,
  });

  let onboardingStatus: OnboardingStatus = 'off';

  switch (data?.data?.status) {
    case 'in_progress':
      onboardingStatus = 'in_progress';
      break;
    case 'completed':
      onboardingStatus = 'completed';
      break;
  }

  const isFlipdishStaffSelector = useMemo(
    () => permissionsSelector.hasPermissionFactory(['FlipdishStaff']),
    []
  );
  const isFlipdishStaff = useAppSelector((state) => isFlipdishStaffSelector(state));
  return {
    onboardingStatus,
    isFlipdishStaff,
    isOnboardingWizardAutoSaveEnabled,
  };
};
